var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkBlackOutlineBlueCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6663 19.9987C36.6663 10.7939 29.2043 3.33203 19.9997 3.33203C10.7949 3.33203 3.33301 10.7939 3.33301 19.9987C3.33301 29.2034 10.7949 36.6654 19.9997 36.6654C29.2043 36.6654 36.6663 29.2034 36.6663 19.9987Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 20.8333L17.4997 25L26.6663 15",
    stroke: "#4956F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkBlackOutlineBlueCheck);
export default __webpack_public_path__ + "static/media/checkmark-black-outline-blue-check.84951ebb5d85c5367a91a2a8f0bf27ec.svg";
export { ForwardRef as ReactComponent };